import request from '@/utils/request'

// 获取部门列表
export function getDepartmentList(data) {
  return request({
    url: '/dept/list',
    method: 'post',
    data
  })
}

// 获取部门树形数据
export function getDepartmentTree() {
  return request({
    url: '/dept/getDeptList',
    method: 'get'
  })
}

// 获取用户数据
export function getUserList() {
  return request({
    url: '/user/getUserList',
    method: 'get'
  })
}

// 新增部门
export function addDepartment(data) {
  return request({
    url: '/dept/addDept',
    method: 'post',
    data
  })
}

// 更新部门
export function updateDepartment(data) {
  return request({
    url: `/department/${data.id}`,
    method: 'put',
    data
  })
}

// 删除部门
export function deleteDepartment(id) {
  return request({
    url: `/department/${id}`,
    method: 'delete'
  })
}

// 获取部门详情
export function getDepartmentDetail(id) {
  return request({
    url: `/department/${id}`,
    method: 'get'
  })
} 